import { INavRoute } from 'app/components';
import { AboutUs } from 'app/containers/AboutUs';
import { AreYouFoundation } from 'app/containers/AreYouAFoundation';
import { ComingSoon } from 'app/containers/ComingSoon';
import { Confirm } from 'app/containers/Confirm';
import { Contractors } from 'app/containers/Contractors';
import { Dashboard } from 'app/containers/Dashboard';
import { EmployeeCompensation } from 'app/containers/EmployeeCompensation';
import { FAQ } from 'app/containers/FAQ';
import { FinancialAdvisory } from 'app/containers/FinancialAdvisory';
import { Home } from 'app/containers/Home';
import { IncomingContributionLeaders } from 'app/containers/IncomingContributionLeaders';
import { Indices } from 'app/containers/Indices';
import { LeagueTable } from 'app/containers/LeagueTable';
import { LegalDisclaimer } from 'app/containers/LegalDisclaimer';
import { MarketIntelligence } from 'app/containers/MarketIntelligence';
import { NewFoundationFormation } from 'app/containers/NewFoundationFormation';
import { Registration } from 'app/containers/Registration';
import { Reports } from 'app/containers/Reports';
import { Resources } from 'app/containers/Resources';
import { SampleReport } from 'app/containers/SampleReport';
import { TermsOfUse } from 'app/containers/TermsOfUse';
import { TrusteeCompensation } from 'app/containers/TrusteeCompensation';
import { UserActivity } from 'app/containers/UserActivity';
import { UserAdd } from 'app/containers/UserAdd';
import { UserAdmin } from 'app/containers/UserAdmin';
import { UserLogin } from 'app/containers/UserLogin';
import { UserActions } from 'app/redux/User/actions';
import * as React from 'react';
import { AnnualInvestment } from '../AnnualInvestment';
import { AssetsAndGrantsContainer } from '../AssetsAndGrantsContainer';
import { Background } from '../Background';
import { FoundationMark50 } from '../FoundationMark50';
import { FoundationMark50Details } from '../FoundationMark50Details';
import { FoundationMarkIndex } from '../FoundationMarkIndex';
import { GIV } from '../GIV';
import { IrsFilingContainer } from '../IrsFiling';
import { PeerGroup } from '../PeerGroup';
import { PeerGroups } from '../PeerGroups';
import { PrivateFoundations } from '../PrivateFoundations';
import { Publications } from '../Publications';

const LoginRoute = {
  single: {
    name: 'Login',
    component: UserLogin,
    path: '/login',
    iconClass: 'fa',
  },
};

const DashboardRoute = {
  single: {
    name: 'Dashboard',
    component: Dashboard,
    path: '/dashboard',
    iconClass: 'fa fa-fw fa-dashboard',
  },
};

const IndicesRoute = {
  multi: {
    iconClass: 'fa',
    name: 'Indices',
    routes: [
      {
        name: 'FoundationMark Index',
        path: '/fmindex',
        component: FoundationMarkIndex,
      },
      {
        name: 'GIV Index',
        path: '/giv',
        component: GIV,
      },
      {
        name: 'Additional GIV Indices',
        path: '/indices',
        component: Indices,
      },
    ],
  },
};

const HomeRoute = {
  hidden: true,
  single: {
    name: 'Home',
    component: Home,
    path: '/',
    iconClass: 'fa',
  },
};

const PublicationsRoute = {
  hidden: true,
  single: {
    name: 'FoundationMark Publications',
    component: Publications,
    path: '/publications',
    iconClass: 'fa',
  },
};

const AboutUsRoute = {
  multi: {
    name: 'About',
    iconClass: 'fa fa-fw fa-files-o',
    routes: [
      {
        name: 'Background',
        path: '/background',
        component: Background,
      },
      {
        name: 'Private Foundations',
        path: '/private-foundations',
        component: PrivateFoundations,
      },
      {
        name: 'Leadership',
        path: '/leadership',
        component: AboutUs,
      },
      {
        name: 'Foundation Universe',
        path: '/resources?state=true',
        component: Resources,
      },
    ],
  },
};

const ComingSoonRoute = {
  hidden: true,
  single: {
    name: 'Coming Soon',
    component: ComingSoon,
    path: '/coming-soon',
    iconClass: 'fa',
  },
};

const ReportsRoute = {
  single: {
    name: 'Reports',
    component: Reports,
    path: '/reports',
    iconClass: 'fa',
  },
};

const ResourcesRoute = {
  multi: {
    name: 'Resources',
    iconClass: 'fa fa-fw fa-files-o',
    routes: [
      {
        name: 'Home',
        path: '/resources',
        component: Resources,
      },
      {
        name: 'Assets and Grantmaking',
        path: '/grants',
        component: AssetsAndGrantsContainer,
      },
      {
        name: 'Publications',
        path: '/publications',
        component: Publications,
      },
      {
        name: 'Peer Groups',
        path: '/peergroup',
        component: PeerGroups,
      },
      {
        name: 'Asset Class Returns',
        path: '/assetClassReturns',
        component: AnnualInvestment,
      },
      {
        name: 'FoundationMark 15',
        path: '/foundationmark15',
        component: FoundationMark50,
      },
      {
        name: 'Market Intelligence',
        path: '/market-intelligence',
        component: MarketIntelligence,
      },
      {
        name: 'Trustee Compensation',
        path: '/trustee-compensation',
        component: TrusteeCompensation,
      },
      {
        name: 'Foundation Advocate',
        path: '/foundationAdvocate',
        component: () => {
          window.location.href = 'https://www.foundationadvocate.com/';
          return null;
        },
      },
    ],
  },
};

const SampleReportRoute = {
  hidden: true,
  single: {
    name: 'Sample Report',
    component: SampleReport,
    path: '/sampleReport',
    iconClass: 'fa',
  },
};

const FAQRoute = {
  hidden: true,
  single: {
    name: 'FAQs',
    component: FAQ,
    path: '/faq',
    iconClass: 'fa fa-fw fa-question-circle',
  },
};

const FoundationMarkDetails = {
  hidden: true,
  single: {
    name: 'FoundationMark Details',
    component: FoundationMark50Details,
    path: '/foundationmark15details',
    iconClass: 'fa fa-fw fa-question-circle',
  },
};

const IrsFiling = {
  hidden: true,
  single: {
    name: 'IRS Filing',
    component: IrsFilingContainer,
    path: '/irs-filing',
    iconClass: 'fa fa-fw fa-question-circle',
  },
};

const LegalDisclaimerRoute = {
  hidden: true,
  single: {
    name: 'Legal Disclaimers',
    component: LegalDisclaimer,
    path: '/legal-disclaimer',
    iconClass: 'fa fa-fw fa-question-circle',
  },
};

const AreYouFoundationRoute = {
  single: {
    name: 'Are you a Foundation?',
    component: AreYouFoundation,
    path: '/are-you-foundation',
    iconClass: 'fa',
  },
};

const TermsOfUseRoute = {
  hidden: true,
  single: {
    name: 'Terms of Use',
    component: TermsOfUse,
    path: '/terms-of-use',
    iconClass: 'fa fa-fw',
  },
};

const LeagueTableRoute = {
  hidden: true,
  single: {
    name: 'League Table',
    component: LeagueTable,
    path: '/league-table',
    iconClass: 'fa',
  },
};

const ContractorsRoute = {
  hidden: true,
  single: {
    name: 'Contractors',
    component: Contractors,
    path: '/contractors',
    iconClass: 'fa',
  },
};

const FinancialAdvisoryRoute = {
  hidden: true,
  single: {
    name: 'Financial Advisory',
    component: FinancialAdvisory,
    path: '/financial-advisory',
    iconClass: 'fa',
  },
};

const NewFoundationFormationRoute = {
  hidden: true,
  single: {
    name: 'New Foundation Formation',
    component: NewFoundationFormation,
    path: '/new-foundation-formation',
    iconClass: 'fa',
  },
};

const IncomingContributionLeadersRoute = {
  hidden: true,
  single: {
    name: 'Incoming Contribution Leaders',
    component: IncomingContributionLeaders,
    path: '/incoming-contribution-leaders',
    iconClass: 'fa',
  },
};

const EmployeeCompensationRoute = {
  hidden: true,
  single: {
    name: 'Employee Compensation',
    component: EmployeeCompensation,
    path: '/employee-compensation',
    iconClass: 'fa',
  },
};

const TrusteeCompensationRoute = {
  hidden: true,
  single: {
    name: 'Trustee Compensation',
    component: TrusteeCompensation,
    path: '/trustee-compensation',
    iconClass: 'fa',
  },
};

const SignOutRoute = {
  single: {
    name: 'Sign Out',
    component: () => <strong>{UserActions.logout() ? null : null}</strong>,
    path: '/signout',
    iconClass: 'fa fa-fw fa-sign-out',
  },
};

const RegistrationRoute = {
  hidden: true,
  single: {
    name: 'Registration',
    component: Registration,
    path: '/register',
    iconClass: 'fa fa-fw fa-user-plus',
  },
};

const ConfirmRoute = {
  hidden: true,
  single: {
    name: 'Confirm Registration',
    component: Confirm,
    path: '/confirm',
    iconClass: 'fa fa-fw fa-user-plus',
  },
};

const UserActivityRoute = {
  single: {
    name: 'User Activity',
    component: UserActivity,
    path: '/useractivity',
    iconClass: 'fa fa-fw fa-user-plus',
  },
};

const UserAdminRoute = {
  hidden: true,
  single: {
    name: 'User Administration',
    component: UserAdmin,
    path: '/useradmin',
    iconClass: 'fa fa-fw fa-user-plus',
  },
};

const UserAddRoute = {
  hidden: true,
  single: {
    name: 'User Administration',
    component: UserAdd,
    path: '/useradd',
    iconClass: 'fa fa-fw fa-user-plus',
  },
};

const UserAdminRoutes = {
  multi: {
    name: 'Admin',
    iconClass: 'fa fa-fw fa-files-o',
    routes: [
      {
        name: 'User Activity',
        path: '/useractivity',
        component: UserActivity,
      },
      {
        name: 'User Administration',
        path: '/useradmin',
        component: UserAdmin,
      },
    ],
  },
};

const PrivatePage1 = {
  single: {
    name: 'Private Page 1',
    component: () => <strong>Private Page 1</strong>,
    path: '/privatepage1',
    iconClass: 'fa fa-fw fa-window-restore',
  },
};

const PrivatePage2 = {
  single: {
    name: 'Private Page 2',
    component: () => <strong>Private Page 2</strong>,
    path: '/privatepage2',
    iconClass: 'fa fa-fw fa-window-restore',
  },
};

const AdminNavRoutes: INavRoute[] = [
  HomeRoute,
  AboutUsRoute,
  SampleReportRoute,
  FAQRoute,
  IndicesRoute,
  ReportsRoute,
  ResourcesRoute,
  AreYouFoundationRoute,
  UserAdminRoutes,
  SignOutRoute,
  TermsOfUseRoute,
  LegalDisclaimerRoute,
  LeagueTableRoute,
  ContractorsRoute,
  FinancialAdvisoryRoute,
  NewFoundationFormationRoute,
  IncomingContributionLeadersRoute,
  EmployeeCompensationRoute,
  TrusteeCompensationRoute,
  ComingSoonRoute,
  ConfirmRoute,
  UserAddRoute,
  PublicationsRoute,
  FoundationMarkDetails,
  IrsFiling,
];

const LoggedOutAppNavRoutes: INavRoute[] = [
  HomeRoute,
  AboutUsRoute,
  SampleReportRoute,
  FAQRoute,
  IndicesRoute,
  ReportsRoute,
  ResourcesRoute,
  AreYouFoundationRoute,
  LoginRoute,
  TermsOfUseRoute,
  LegalDisclaimerRoute,
  RegistrationRoute,
  ConfirmRoute,
  ComingSoonRoute,
  LeagueTableRoute,
  ContractorsRoute,
  FinancialAdvisoryRoute,
  NewFoundationFormationRoute,
  IncomingContributionLeadersRoute,
  EmployeeCompensationRoute,
  TrusteeCompensationRoute,
  PublicationsRoute,
  FoundationMarkDetails,
  IrsFiling,
];

const LoggedInAppNavRoutes: INavRoute[] = [
  HomeRoute,
  AboutUsRoute,
  SampleReportRoute,
  FAQRoute,
  IndicesRoute,
  ReportsRoute,
  ResourcesRoute,
  AreYouFoundationRoute,
  SignOutRoute,
  TermsOfUseRoute,
  LegalDisclaimerRoute,
  LeagueTableRoute,
  ContractorsRoute,
  FinancialAdvisoryRoute,
  NewFoundationFormationRoute,
  IncomingContributionLeadersRoute,
  EmployeeCompensationRoute,
  TrusteeCompensationRoute,
  ComingSoonRoute,
  ConfirmRoute,
  PublicationsRoute,
  FoundationMarkDetails,
  IrsFiling,
];

//Multi Route Demo
// {
//   multi: {
//     name: 'Multi Page',
//     iconClass: 'fa fa-fw fa-files-o',
//     routes: [
//       {
//         name: 'Fake Page 1',
//         path: '/fake1',
//         component: Blank,
//       },
//       {
//         name: 'Fake Page 2',
//         path: '/fake2',
//         component: Blank,
//       }
//     ]
//   }
// }

export { LoggedInAppNavRoutes, LoggedOutAppNavRoutes, AdminNavRoutes };



// WEBPACK FOOTER //
// ./src/app/containers/App/routes.tsx